import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { AppActions } from 'src/store/AppReducer';
import React, { useEffect, useState } from 'react';
import Event from '../yearPlan/Event';
import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { getLeaveForSelectedMonth } from 'src/services/yearPlannerService';
import { Leave } from 'src/models/leave';
import { useDispatch } from 'react-redux';

const CalenderView = () => {
  const dispatch = useDispatch();
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const calendarRef: any = React.createRef();
  const monthPickerRef: any = React.createRef();
  const [loadedEvents, setLoadedEvents] = useState([] as Leave[]);

  const commonTextColor = '#000000';
  const commonBackgroundColor = '#DCE7F2';

  const updateLeaveColor = (leaves: Leave[]) => {
    (leaves || []).map((item, i) => {
      item.textColor = commonTextColor;
      item.color = commonBackgroundColor;
      item.title = item.summery;
    });
    return leaves;
  };


  // On Loading the Calander
  useEffect(() => {
    dispatch(AppActions.showLoader());
    const currentDate = new Date();
    getLeaveForSelectedMonth(
      currentDate.getMonth() + 1,
      currentDate.getFullYear()
    ).then((res) => {
      setLoadedEvents(updateLeaveColor(res.data as Leave[]));
      dispatch(AppActions.hideLoader());
    });
  }, []);

  const convertDate = (str: string) => {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  };

  const renderEvent = (arg: any) => {

    if (arg.textColor === '#00B26A') {
      return (
        <Event
          date={convertDate(arg.event._instance.range.start)}
          color={arg.textColor}
          backgroundColor={arg.backgroundColor}
          text={arg.event._def.title}
          dayType={arg.event._def.extendedProps.dayType}
          holidayType={arg.event._def.extendedProps.type}
        />
      );
    } else {
      return (
        <Event
          date={convertDate(arg.event._instance.range.start)}
          color={arg.textColor}
          backgroundColor={arg.backgroundColor}
          text={arg.event._def.title}
          dayType={arg.event._def.extendedProps.dayType}
          holidayType={arg.event._def.extendedProps.type}
        />
      );
    }
  };

  const mobileCheck = () => {
    if (window.innerWidth >= 768) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div>
        <DatePicker
          openTo={mobileCheck() ? 'day' : 'month'}
          ref={monthPickerRef}
          views={mobileCheck() ? ['year', 'month', 'day'] : ['year', 'month']}
          // label="Year and Month"
          minDate={new Date('2022-01-01')}
          maxDate={new Date('2032-12-31')}
          value={selectedMonth}
          onChange={(res: any) => {
            let date = res as Date;
            getLeaveForSelectedMonth(
              date.getMonth() + 1,
              date.getFullYear()
            ).then((res) => {
              setLoadedEvents(updateLeaveColor(res.data as Leave[]));
            });

            setSelectedMonth(res);
            let calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(res);
          }}
          renderInput={(params: any) => {
            return <TextField {...params} style={{ marginBottom: 10 }} />;
          }}
        />
      </div>
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
        views={{
          newView: {
            type: 'dayGridDay'
          }
        }}
        headerToolbar={false}
        fixedWeekCount={false}
        initialView={mobileCheck() ? 'newView' : 'dayGridMonth'}
        showNonCurrentDates={true}
        selectable={true}
        events={loadedEvents}
        eventContent={renderEvent}
        height={window.innerHeight - window.innerHeight * (40 / 100)}
        expandRows={true}
        displayEventTime={false}
        eventDisplay={'title'}
        handleWindowResize={true}
      />
    </>
  );
};
export default CalenderView;
